// extracted by mini-css-extract-plugin
export var bullet = "PartnerCtaSection-module__bullet___1-0Yv";
export var bulletList = "PartnerCtaSection-module__bulletList___ohFuV";
export var description = "PartnerCtaSection-module__description___t8QXF";
export var joinButton = "PartnerCtaSection-module__joinButton___XYqrE";
export var section = "PartnerCtaSection-module__section___Et-WI";
export var title = "PartnerCtaSection-module__title___komdf";